import { ChangeDetectionStrategy, Component, inject, Input, OnInit, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import SignaturePad from 'signature_pad';
import { FormControl, Validators } from '@angular/forms';
import { AnswersStore } from 'src/app/store/answers-store';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { map } from 'rxjs';
import { Answer } from 'src/app/models/Answer.model';
import { Question } from 'src/app/models/question.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { QueDatePipe } from 'src/app/pipes/date.pipe';

@Component({
    selector: 'que-signature-display',
    imports: [CommonModule, TranslateDirective, TranslatePipe, QueDatePipe],
    templateUrl: './signature-display.component.html',
    styleUrls: ['./signature-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignatureDisplayComponent implements OnInit {
  @Input()
  question?: Question;
  @Input()
  isDisplay?: boolean;
  @Input() viewAnswer = false;
  signPad: any;
  @ViewChild('signPadCanvas', { static: false }) signaturePadElement: any;
  // signImage:any;

  myAnswer?: Answer;
  answer = new FormControl<string>("", [Validators.required]);
  #answerStore = inject(AnswersStore);
  #questionnaireStore = inject(QuestionnaireStore);
  isNotUser$ = toSignal(this.#questionnaireStore.isUser$.pipe(map(x => !x)));

  sigbatureDate$: WritableSignal<Date | undefined> = signal(undefined);
  ngOnInit(): void {

    this.answer.valueChanges.subscribe(
      ans => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.sigbatureDate$.set(today);
        if (ans == "" || !ans) {
          this.sigbatureDate$.set(undefined);
        }
        this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, questionType: this.question?.type.id, base64: ans ?? "", isValid: this.answer.valid, dateAnswerNTZ: this.sigbatureDate$() })
      });

    this.#answerStore.answers$.pipe(map(arr => arr.find(ans => ans.questionId == this.question?.id))).subscribe(x => {
      if (x) {
        this.myAnswer = x;
        if (x.base64) {
          this.answer.setValue(x.base64, { emitEvent: false });
        }
        if (x.dateAnswerNTZ) {
          this.sigbatureDate$.set(x.dateAnswerNTZ);
        }
      }
    }).unsubscribe();
  }

  ngAfterViewInit() {
    this.signPad = new SignaturePad(this.signaturePadElement.nativeElement);
    if (this.myAnswer?.base64)
      this.signPad.fromDataURL(this.myAnswer.base64);

    this.signPad.addEventListener('endStroke', () => this.saveSignPad());
  }
  /*Undo last step from the signature*/
  undoSign() {
    const data = this.signPad.toData();
    if (data.length >= 0) {
      data.pop(); // remove the last step
      this.signPad.fromData(data);
      const base64ImageData = this.signPad.toDataURL();
      this.answer.setValue(base64ImageData);
    }
    if (data.length === 1) {
      data.pop(); // remove the last step
      this.signPad.fromData(data);
      this.answer.setValue('');
    }
    else {
      this.answer.setValue('');
      this.signPad.clear()
    }
  }
  /*Clean whole the signature*/
  clearSignPad() {
    this.signPad.clear();
  }
  /*Here you can save the signature as a Image*/
  saveSignPad() {
    if (!this.signPad._isEmpty) {
      const base64ImageData = this.signPad.toDataURL();
      // this.signImage = base64ImageData;
      this.answer.setValue(base64ImageData);
      //Here you can save your signature image using your API call.
    }
  }

}
